/**
 * @ngdoc overview
 * @name userSession
 * @description
 * - When a user selects a customer, set it as active in the CCA Session.
 * - When a user logs in create a new CCA Session.
 * - When a user logs out it clears any existing session and data.
 *
 * @param {Object}  $rootScope        To listen for the necessary events.
 * @param {Object}  appConstant       The app configuration dictionary.
 * @param {Service} appUtils          To get the Admin accounts.
 * @param {Service} campaignsService  To clear the saved content.
 * @param {Service} ccaSession        To destroy the current Session.
 * @param {Service} fullStory         To clear the FullStory's cookies when the user logout.
 * @param {Object}  AUTH_EVENTS       The name of the events the method needs to listen for.
 * @memberof account
 */
const userSession = (
  $rootScope,
  appConstant,
  appUtils,
  campaignsService,
  ccaSession,
  fullStory,
  AUTH_EVENTS,
) => {
  'ngInject';

  const clearSavedContent = () => {
    campaignsService.clearContent();
  };

  const setActiveAccount = (event, account) => {
    ccaSession.setActiveAccount(account);
    clearSavedContent();
    $rootScope.$broadcast(AUTH_EVENTS.customerChanged, account);

    if (appConstant.features.fullStory.enabled) {
      const user = ccaSession.getUser();
      fullStory.identify(user.email, {
        email: user.email,
        displayName: user.name,
        brand_str: account.customer.name,
        brandId_str: account.customer.id.toString(),
      });
    }
  };

  const removeCusSelected = $rootScope.$on(AUTH_EVENTS.customerSelected, setActiveAccount);

  const removeLoginSuccess = $rootScope.$on(AUTH_EVENTS.loginSuccess, (event, session) => {
    ccaSession.storeSession(session);
    // If there is only one available account, select it as active
    const accounts = appUtils.getAdminAccounts(session.accounts);
    if (accounts.length === 1) {
      const [account] = accounts;
      setActiveAccount(event, account);
    }
  });

  const removeLogoutSuccess = $rootScope.$on(AUTH_EVENTS.logoutSuccess, () => {
    ccaSession.destroySession();
    clearSavedContent();

    if (appConstant.features.fullStory.enabled) {
      fullStory.clearUserCookie();
    }
  });

  $rootScope.$on('$destroy', () => {
    removeCusSelected();
    removeLoginSuccess();
    removeLogoutSuccess();
  });
};

export default userSession;



// WEBPACK FOOTER //
// ./src/frontend/modules/account/eventSubscribers/userSession.js